import type { ProgressBarProps } from "../types/components.js";

export function ProgressBar({ value, label, layout = "stacked" }: ProgressBarProps) {
  const bounded = value === null ? null : Math.min(100, Math.max(0, value));
  const inline = layout === "inline";
  return (
    <div
      className={
        inline
          ? "grid grid-cols-[minmax(0,1fr)_minmax(3rem,6.5rem)_2.5rem] items-center gap-3 text-xs"
          : "grid grid-cols-[1fr_auto] gap-x-3 gap-y-2 text-sm"
      }
    >
      <span className="min-w-0 truncate leading-snug text-muted-foreground" title={label}>
        {label}
      </span>
      <div
        aria-label={label}
        aria-valuemax={bounded === null ? undefined : 100}
        aria-valuemin={bounded === null ? undefined : 0}
        aria-valuenow={bounded ?? undefined}
        className={`h-1.5 overflow-hidden rounded-full bg-muted/50 ${inline ? "" : "col-span-2 row-start-2"}`}
        role={bounded === null ? "img" : "progressbar"}
      >
        <div
          className="h-full rounded-full bg-success-foreground transition-all"
          style={{ width: `${bounded ?? 0}%` }}
        />
      </div>
      <span className="text-right tabular-nums text-muted-foreground">
        {bounded === null ? "—" : `${Math.round(bounded)}%`}
      </span>
    </div>
  );
}
